export default __webpack_public_path__ + "static/RTG_PDP_LOGO_RTGKIDS_785x100-9213e1776aebf4d37fb3abcdf6763e80.png";